const FLEX_SITE_URL = 'https://vaiaflex.co.za/'

const specials = [
  {
    name: 'Family Time',
    text: 'Holidays planned for the whole family, with flights, stays and the practical details already arranged.',
  },
  {
    name: 'Two of Us',
    text: 'Shorter trips for two, with the stay, flights and transfers priced together.',
  },
  {
    name: 'Duo',
    text: 'Trips built around an event or experience, kept to a small number of bookings.',
  },
]

export default function FlexPackages() {
  return (
    <section className="mt-16 border-t border-line pt-12" aria-labelledby="vaia-flex-heading">
      <div className="grid min-w-0 items-center gap-8 lg:grid-cols-2">
        <div className="min-w-0 overflow-hidden rounded-[20px] border border-line">
          <img
            src="/hero/mauritius.jpg"
            alt="A waterfall falling through sunlit forest"
            className="h-[280px] w-full max-w-full object-cover sm:h-[360px] lg:h-[460px]"
          />
        </div>
        <div className="min-w-0">
          <div className="eyebrow">VAIA Flex</div>
          <h2 id="vaia-flex-heading" className="m-0 text-2xl sm:text-[30px]">
            VAIA Flex holidays
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink-soft">
            VAIA Flex is where you book a ready-made holiday and pay your way. Flights, stays and extras
            are already priced. You choose a special, tell us who is travelling, and a VAIA person checks
            availability before sending a payment link. Settle it with Happy Pay, card or EFT. Each special
            takes only four bookings.
          </p>
          <ul className="mt-6 space-y-3">
            {specials.map((special) => (
              <li key={special.name} className="rounded-[14px] border border-line bg-paper px-4 py-3">
                <p className="text-sm font-bold text-forest">{special.name}</p>
                <p className="mt-1 text-sm leading-relaxed text-ink-soft">{special.text}</p>
              </li>
            ))}
          </ul>
          <a
            href={FLEX_SITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary mt-7"
          >
            Visit VAIA Flex
          </a>
        </div>
      </div>
    </section>
  )
}
